import { CustomButton } from "@/components/ui/Buttons";
import Modal from "@/components/ui/Modal";
import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import ShippingConfirmationModal from "./ShippingConfirmationModal";

interface CreatorShippingDetails {
  address: string;
  city: string;
  creator_id: string;
  email: string;
  name: string;
  number: string;
  _id: string;
}

interface ShipProductProps {
  creator_shipping_details: CreatorShippingDetails;
  id: string;
}

const ShipProduct = ({ creator_shipping_details, id }: ShipProductProps) => {
  const [isOpen, setIsOpen] = useState(false);
  // console.log(creator_shipping_details);

  return (
    <div className="p-6 rounded-xl bg-amber-50 border border-amber-200 mb-4">
      <div className="flex flex-col md:flex-row gap-6 justify-between md:items-center">
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <AlertTriangle className="text-amber-500 mt-1 size-5" />
            <div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-2">
                <h2 className="text-base md:text-lg font-semibold text-gray-900">
                  Shipping Details Updated - Ship Product Promptly
                </h2>
                <span className="inline-flex items-center gap-2 bg-amber-500 px-3 py-1 rounded-full">
                  <span className="size-2.5 rounded-full bg-white animate-pulse" />
                  <span className="text-white text-xs font-medium">
                    Ship the product
                  </span>
                </span>
              </div>
              <p className="text-sm leading-6 text-gray-600">
                We've reassigned your project to a new creator. Their address
                has been shared with you. To ensure the project continues
                smoothly, please ship the product within 24 hours.
              </p>
            </div>
          </div>
        </div>
        <CustomButton
          onClick={() => setIsOpen(true)}
          variant="outline"
          color="#334155"
          fontSize="14px"
          fontWeight="600"
          border="1px solid #CBD5E1"
          borderRadius="100px"
          padding="12px 28px"
          className="leading-5 tracking-[-0.5px] hover:bg-amber-500 hover:text-white hover:border-amber-500 transition-colors"
        >
          View details
        </CustomButton>
      </div>
      <Modal width="480px" padding="24px" isOpen={isOpen} setOpen={setIsOpen}>
        <ShippingConfirmationModal
          setIsModalOpen={setIsOpen}
          creator_shipping_details={creator_shipping_details}
          id={id}
        />
      </Modal>
    </div>
  );
};

export default ShipProduct;
